import React from "react";
import propTypes from "prop-types";
import { Col, Row } from "reactstrap";
import styled, { css } from "react-emotion";
import Slider from "react-slick";

const GridContainer = styled("div")`
  @media (max-width: 767px) {
    flex-direction: column;
    height: 900px;
    overflow: hidden;
    min-height: 900px;
  }

  @media (min-width: 768px) {
    max-height: 600px;
    flex-direction: column;
  }
`;

const dynamicImage = props =>
  css`
    background-image: url(${props.image});
  `;

const GridImage = styled("div")`
  @media (max-width: 767px) {
    ${dynamicImage};
    height: 200px;
    max-height: 200px;
    width: 100%;
    overflow: hidden;
    max-width: 100%;
    background-size: cover;
  }

  @media (min-width: 768px) {
    ${dynamicImage};
    height: 400px;
    max-height: 400px;
    overflow: hidden;
    background-size: cover;
  }
`;

const GridSlider = styled(Slider)`
  @media (max-width: 767px) {
    ${dynamicImage};
    height: 200px;
    max-height: 200px;
    width: 100%;
    overflow: hidden;
    max-width: 100%;
    background-size: cover;
  }

  @media (min-width: 768px) {
    ${dynamicImage};
    height: 400px;
    max-height: 400px;
    width: calc(100% / 3);
    overflow: hidden;
    max-width: calc(100% / 3);
    background-size: cover;
  }
`;

const GridSliderLong = styled(Slider)`
  @media (max-width: 767px) {
    ${dynamicImage};
    height: 200px;
    max-height: 200px;
    width: 100%;
    overflow: hidden;
    max-width: 100%;
    background-size: cover;
  }

  @media (min-width: 768px) {
    ${dynamicImage};
    height: 600px;
    max-height: 600px;
    width: calc(100% / 3);
    overflow: hidden;
    max-width: calc(100% / 3);
    background-size: cover;
  }
`;

const GridImageLong = styled("div")`
  @media (max-width: 767px) {
    ${dynamicImage};
    height: 200px;
    max-height: 200px;
    width: 100%;
    overflow: hidden;
    max-width: 100%;
    background-size: cover;
  }

  @media (min-width: 768px) {
    ${dynamicImage};
    height: 600px;
    max-height: 600px;
    overflow: hidden;
    background-size: cover;
  }
`;
const dynamicColor = props =>
  css`
    background-color: ${props.color} !important;
  `;

const GridKeyword = styled("div")`
  @media (max-width: 767px) {
    height: 100px;
    max-height: 100px;
    width: 100%;
    overflow: hidden;
    max-width: 100;
    min-width: 30%;
    ${dynamicColor};
    display: flex;
    align-items: center;
    justify-content: center;
  }

  @media (min-width: 768px) {
    height: 200px;
    max-height: 200px;
    width: calc(100% / 3);
    overflow: hidden;
    max-width: calc(100% / 3);
    min-width: calc(100% / 3);
    ${dynamicColor};
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;

const Keyword = styled("p")`
  text-transform: uppercase;
  color: #ffffff !important;
  font-size: 22px;
  font-weight: 100;
  text-align: center;
`;

export default class Grid3ColumnLong extends React.Component {
  constructor(props) {
    super(props);

    this.colors =  {
      primary: '#0055a4',
      secondary: '#8ca2d4',
      tertiary: '#bcc5e6',
      primaryDark: '#adadad',
      secondaryDark: '#d4d4d4',
      tertiaryDark: '#e5e5e5'
    }
  }

  render() {
    return (
      <Row>
        <Col md="12">
          <GridContainer className="d-flex flex-wrap">
            <GridSlider {...{ fade: true, speed: 3000, autoplay: true, autoplaySpeed: 5000 }}>
              <GridImage image={this.props.image1_1.image} />
              <GridImage image={this.props.image1_2.image} />
            </GridSlider>
            <GridKeyword color={this.colors.secondary}>
              <Keyword>{this.props.callout1}</Keyword>
            </GridKeyword>
            <GridKeyword color={this.colors.primary}>
              <Keyword>{this.props.callout2}</Keyword>
            </GridKeyword>
            <GridSlider {...{ fade: true, speed: 3000, autoplay: true, autoplaySpeed: 5000 }}>
              <GridImage image={this.props.image2_1.image} />
              <GridImage image={this.props.image2_2.image} />
            </GridSlider>
            <GridSliderLong {...{ fade: true, speed: 3000, autoplay: true, autoplaySpeed: 5000 }}>
              <GridImageLong image={this.props.image3_1.image} />
              <GridImageLong image={this.props.image3_2.image} />
            </GridSliderLong>
          </GridContainer>
        </Col>
      </Row>
    );
  }
}

Grid3ColumnLong.propTypes = {
  callout1: propTypes.string.isRequired,
  callout2: propTypes.string.isRequired,
  callout3: propTypes.string.isRequired,
  image1_1: propTypes.object.isRequired,
  image1_2: propTypes.object.isRequired,
  image2_1: propTypes.object.isRequired,
  image2_2: propTypes.object.isRequired,
  image3_1: propTypes.object.isRequired,
  image3_2: propTypes.object.isRequired
};



// WEBPACK FOOTER //
// ./src/components/Grid3ColumnLong.js